module.exports = __webpack_public_path__ + "img/fayi_02.dd54bcbf.jpg";